export default "__VITE_ASSET__Dcu_a81p__"